import styled from 'styled-components';
import { CaptionMixin } from '@qover/typography';

export const Banner = styled.div`
  ${CaptionMixin};
  background: ${props => props.theme.colors.secondary()};
  color: white;
  left: -40px;
  max-width: 140px;
  padding: 5px 40px;
  position: absolute;
  text-align: center;
  top: 12px;
  transform: rotate(-45deg);
  z-index: 4;
`;
